<template>
<div class="agreement">
  <div>
    <div v-html="agreementText"></div>
    <v-checkbox
      v-model="agreed"
      :label="agreementAffirmation"
    ></v-checkbox>
  </div>
  <div class="buttons">
    <v-btn
      class="submit-button"
      color="primary"
      :disabled="!agreed"
      @click="$emit('agreed')">
      {{ agreementButton }}
    </v-btn>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Agreement',
  computed: {
    ...mapState([
      'agreementText',
      'agreementAffirmation',
      'agreementButton',
    ]),
  },
  data() {
    return {
      agreed: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.agreement {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
  }
}

@media (min-width: $breakpoint-tablet) {
  .agreement {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }
  }
}
</style>
